import React from 'react';
import _FormCreateFair from './_FormCreateFair.scss';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Input, Textarea, RichTextarea, DatePicker} from 'components/danangtrade-forms/common';
import GroupSubCategoryMultipleSelect from 'components/danangtrade-forms/GroupSubCategoryMultipleSelect';
import CategoryMultipleSelect from 'components/danangtrade-forms/CategoryMultipleSelect';
import {SingleImageUploader, MultipleImageUploader} from 'components/uploader';
import {Fairs} from 'api';
import {toastr} from 'react-redux-toastr';
import {ShowIf} from 'components/utils';
import CONFIG from 'base/constants/config';

class FormCreateFair extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formAddFair'] = [];

    this.state = {
      name: '',
      description: '',
      banners: [],
      startDate: '',
      endDate: '',
      categoryIds: [],
      groupSubCategory: [],
      content: '',
      webUrl: '',
      apiUrl: '',
      logo: '',
      backgroundLeft: '',
      backgroundRight: '',
      backgroundPattern: '',
      theme: '',
      inviteEmailInfo: {},
      approveEmailInfo: {}
    };
  }

  bindData(data) {
    const {name, description, banners, startDate, endDate, content, webUrl, apiUrl, themeInfo, inviteEmailInfo, approveEmailInfo } = data;

    this.setState({
      name, description, banners, startDate: new Date(startDate), endDate: new Date(endDate), content, webUrl, apiUrl,
      inviteEmailInfo: inviteEmailInfo || {},
      approveEmailInfo: approveEmailInfo || {},
      logo: themeInfo && themeInfo.logo,
      backgroundLeft: themeInfo && themeInfo.backgroundLeft,
      backgroundRight: themeInfo && themeInfo.backgroundRight,
      backgroundPattern: themeInfo && themeInfo.backgroundPattern,
      categoryIds: themeInfo && themeInfo.categoryIds || [],
      groupSubCategory: themeInfo && themeInfo.groupSubCategory || [],
      theme: themeInfo && themeInfo.theme
    });
  }

  componentDidMount() {
    if (this.props.data) {
      this.bindData(this.props.data);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.state.data) {
      this.bindData(nextProps.data);
    }
  }

  submitForm(e) {
    //do something
    e.preventDefault();
    if (this.validateSubmitForm()) {
      let params = {};
      let data = {
        name: this.state.name || '',
        description: this.state.description || '',
        banners: this.state.banners || [],
        startDate: this.state.startDate || '',
        endDate: this.state.endDate || '',
        content: this.state.content || '',
        webUrl: this.state.webUrl || '',
        apiUrl: this.state.apiUrl || '',
        inviteEmailInfo: {
          banner: this.state.inviteEmailInfo.banner || null,
          content: this.state.inviteEmailInfo.content || null,
          vitradeSiteURL: this.state.inviteEmailInfo.vitradeSiteURL || 'https://vitrade.vn',
          pavoSiteURL: this.state.webUrl || ''
        },
        approveEmailInfo: {
          banner: this.state.approveEmailInfo.banner || null,
          content: this.state.approveEmailInfo.content || null,
          vitradeSiteURL: this.state.approveEmailInfo.vitradeSiteURL || 'https://vitrade.vn',
          pavoSiteURL: this.state.webUrl || ''
        },
      };
      data.categoryIds = this.getCategoryIds();
      data.themeInfo = {
        logo: this.state.logo,
        backgroundLeft: this.state.backgroundLeft,
        backgroundRight: this.state.backgroundRight,
        backgroundPattern: this.state.backgroundPattern,
        categoryIds: this.state.categoryIds,
        groupSubCategory: this.state.groupSubCategory,
        theme: this.state.theme
      }
      if (this.props.data && typeof this.props.data.id !== "undefined") {
        params = {id: this.props.data.id};
      }
      return this.props.dispatch(this.props.fnSubmit(params, data)).then(response => {
        if (typeof this.props.cb === 'function') {
          this.props.cb(response);
        }
        return Promise.resolve(response);
      }).catch(err => {
        toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
        Promise.reject(err);
      });

    }
    return false;
  }

  getCategoryIds() {
    let categoryIds = [];
    this.state.categoryIds && this.state.categoryIds.map(item => {
      categoryIds.push(item.value)
    })

    this.state.groupSubCategory && this.state.groupSubCategory.map(item => {
      item.data && item.data.map(itemData => {
        categoryIds.push(itemData.value)
      })
    })

    return categoryIds
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formAddFair'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });

    if (!pass) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }

    return pass;
  }

  onChange(name, e) {
    if (e && e.target) {
      this.setState({
        [name]: e.target.value
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  selectCategories(categoryIds) {
    this.props.validators['formAddFair'] = [];
    let groupSubCategory = [];
    categoryIds.map(item => {
      let indexItem = this.state.groupSubCategory.findIndex(i => i.parentId === item.value);
      if (indexItem !== -1) {
        groupSubCategory = [
          ...groupSubCategory,
          this.state.groupSubCategory[indexItem]
        ]
      } else {
        groupSubCategory = [
          ...groupSubCategory,
          {
            parentId: item.value,
            label: item.label,
            data: []
          }
        ]
      }
    })
    this.setState({
      categoryIds,
      groupSubCategory
    });
  }

  onRemoveImage(name, image) {
    if(name === 'banners') {
      this.setState({
        [name]: image
      });
    } else {
      this.setState({[name]: image.name})
    }
  }

  onUploadComplete(name, image) {
    if(name === 'banners') {
      this.setState({
        [name]: image
      });
    } else {
      this.setState({
        [name]: image.name
      });
    }
  }

  selectSubCategories(parentId, value) {
    let indexItem = this.state.groupSubCategory.findIndex(item => item.parentId === parentId)
    if (indexItem !== -1) {
      this.state.groupSubCategory[indexItem].data = value
      this.setState({
        groupSubCategory: this.state.groupSubCategory
      })
    }
  }

  render() {
    return (
      <div className="register-fair-box">
        <form onSubmit={this.submitForm.bind(this)} className='create-form'>
          <div className='form-create-col'>
            <div className="register-box-body form-group">
              <Input type="text" placeholder="Tên hội chợ..."
                className='has-feedback fg-custom'
                value={this.state.name}
                required
                onChange={this.onChange.bind(this, 'name')}
                bindValidator={this} channel="formAddFair"
                errorMessage="Tên hội chợ không được để trống"
              />
              <Textarea type="text" placeholder="Mô tả..."
                className='fg-custom vitrade-textarea'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.description}
                onChange={this.onChange.bind(this, 'description')}
                required
                bindValidator={this} channel="formAddFair"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />
            </div>
            <div className="register-box-body">
              <DatePicker type="text" placeholder="Từ ngày..."
                className='has-feedback fg-custom form-group'
                value={this.state.startDate}
                onChange={this.onChange.bind(this, 'startDate')}
                required
                bindValidator={this} channel="formAddFair"
                errorMessage="Bạn vui lòng điền ngày bắt đầu hội chợ"
              />
              <DatePicker type="text" placeholder="Đến ngày..."
                className='has-feedback fg-custom form-group'
                value={this.state.endDate}
                onChange={this.onChange.bind(this, 'endDate')}
                required
                bindValidator={this} channel="formAddFair"
                errorMessage="Bạn vui lòng điền ngày kết thúc hội chợ"
              />
              <Input type="text" placeholder="Link API..."
                className='has-feedback fg-custom'
                value={this.state.apiUrl}
                onChange={this.onChange.bind(this, 'apiUrl')}
                required
                bindValidator={this} channel="formAddFair"
                errorMessage="Bạn vui lòng điền link API của hội chợ"
              />
              <Input type="text" placeholder="Link front page..."
                className='has-feedback fg-custom'
                value={this.state.webUrl}
                onChange={this.onChange.bind(this, 'webUrl')}
                required
                bindValidator={this} channel="formAddFair"
                errorMessage="Bạn vui lòng điền Link front page hội chợ"
              />
              {/* multiSelectBox */}
              <CategoryMultipleSelect
                label="Chọn lĩnh vực của hội chợ"
                value={this.state.categoryIds}
                onChange={this.selectCategories.bind(this)}
                required
                bindValidator={this} channel="formAddFair"
              />

              {
                this.state.groupSubCategory && this.state.groupSubCategory.map(item => {
                  return (
                    <GroupSubCategoryMultipleSelect
                      key={item.parentId}
                      parentId={item.parentId}
                      label={item.label}
                      value={item.data}
                      onChange={this.selectSubCategories.bind(this, item.parentId)}
                      required
                      bindValidator={this} channel="formAddFair"
                    />
                  )
                })
              }

              <Textarea type="text" placeholder="Nội dung..."
                className='fg-custom vitrade-textarea'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.content}
                onChange={this.onChange.bind(this, 'content')}
                required
                bindValidator={this} channel="formAddFair"
                errorMessage="Bạn vui lòng nhập nội dung"
                maxLength={null}
              />

              {/*<RichTextarea type="text" placeholder="Nội dung..."
                heading={
                  () => <h3 className='wrap-product-des-title'>Nội dung</h3>
                }
                className='wrap-product-des'
                inputClassName='product-des-input'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.content}
                onChange={this.onChange.bind(this, 'content')}
                required={true}
                bindValidator={this} channel="formPostArticle"
                errorMessage="Bạn vui lòng nhập nội dung"
                uploadCallback={
                  (file) => {
                    let data = new FormData();
                    data.append('fileUpload', file);
                    return Articles.actions.upload.request({}, {
                      data
                    }).then(response => {
                      let link = `${CONFIG.UploadImageURL}/resize/800x600/articles/download/${response.data.result.files.fileUpload[0].name}`;
                      return Promise.resolve({
                        data: {
                          link
                        }
                      })
                    })
                  }
                }
              />*/}

              <div>
                <ShowIf condition={this.props.data}>
                  <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">CẬP NHẬT HỘI CHỢ</button>
                </ShowIf>
                <ShowIf condition={!this.props.data}>
                  <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">THÊM HỘI CHỢ</button>
                </ShowIf>

              </div>
            </div>
          </div>
          <div className='form-create-col'>

            <SingleImageUploader
              fnUpload={Fairs.actions.upload.request}
              onUploadComplete={this.onUploadComplete.bind(this, 'logo')}
              onRemoveImage={this.onRemoveImage.bind(this, 'logo')}
              title='Logo hội chợ, kích thước đề xuất 430x100'
              image={this.state.logo}
              type='FAIR'
            />
            <div className='add-product'>
              <MultipleImageUploader
                fnUpload={Fairs.actions.upload.request}
                onUploadComplete={this.onUploadComplete.bind(this, 'banners')}
                onRemoveImage={this.onRemoveImage.bind(this, 'banners')}
                heading='Ảnh, banner hội chợ'
                images={this.state.banners}
                type='FAIR'
              />
            </div>
            <SingleImageUploader
              fnUpload={Fairs.actions.upload.request}
              onUploadComplete={this.onUploadComplete.bind(this, 'backgroundLeft')}
              onRemoveImage={this.onRemoveImage.bind(this, 'backgroundLeft')}
              title='Hình nền trang chủ bên trái'
              image={this.state.backgroundLeft}
              type='FAIR'
            />
            <SingleImageUploader
              fnUpload={Fairs.actions.upload.request}
              onUploadComplete={this.onUploadComplete.bind(this, 'backgroundRight')}
              onRemoveImage={this.onRemoveImage.bind(this, 'backgroundRight')}
              title='Hình nền trang chủ bên phải'
              image={this.state.backgroundRight}
              type='FAIR'
            />
            <SingleImageUploader
              fnUpload={Fairs.actions.upload.request}
              onUploadComplete={this.onUploadComplete.bind(this, 'backgroundPattern')}
              onRemoveImage={this.onRemoveImage.bind(this, 'backgroundPattern')}
              title='Hình nền chính trang chủ hội chợ'
              image={this.state.backgroundPattern}
              type='FAIR'
            />
          </div>

        </form>
      </div>
    );
  }
}

FormCreateFair.defaultProps = {
  validators: {
    formAddFair: []
  }
};

const bindStateToProps = state => {
  return {
    auth: state.auth
  };
};

export default withRouter(connect(bindStateToProps)(FormCreateFair));



// WEBPACK FOOTER //
// ./components/fair/FormCreateFair.jsx